export default "__VITE_ASSET__B4N$W4di__"